import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Img from "gatsby-image"

const StyledImg = styled(Img)`
    position: absolute;
    opacity: 0;
    transition: opacity ${props => (props.isPaused ? "0" : "2s")};
    transition-timing-function: linear;
    height: 100%;
    width: 100%;
    object-fit: contain;
    img {
        object-fit: contain;
    }
    &.active {
        opacity: 1;
        z-index: 0;
    }
`

export default function Hero({ images, data, altImages }) {
    const [active, setActive] = useState(
        Math.floor(Math.random() * data.length)
    )
    const [intervalID, setIntervalID] = useState(0)
    const [isPaused, setIsPaused] = useState(false)

    const goToImage = key => {
        clearInterval(intervalID)
        setIsPaused(true)
        setActive(key)
    }

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setIntervalID(interval)
    //         setActive(active => {
    //             if (active === data.length - 1) {
    //                 return 0
    //             } else {
    //                 return active + 1
    //             }
    //         })
    //     }, 7000)
    //     return () => clearInterval(interval)
    // }, [data.length])

    return (
        <React.Fragment>
            {data.map((el, key) => {
                return (
                    <StyledImg
                        fluid={altImages[el].fluid}
                        key={key}
                        className={key === active ? "active" : null}
                        isPaused={isPaused}
                        style={{
                            position: "absolute",
                        }}
                        placeholderStyle={{
                            opacity: "0.1",
                            filter: "blur(10px)",
                            background: "lightgreen",
                        }}
                    />
                )
            })}
        </React.Fragment>
    )
}
